import { isReferenceJob } from './reference-job';

export interface LambdaTarget {
    id: number;
    body: { job: number } | { reference_job: number };
    type: 'task' | 'reference';
}

// AI tools run against the task for drawing jobs and against the reference for reference jobs.
export function lambdaTarget(job: any): LambdaTarget {
    return isReferenceJob(job) ?
        { id: job.referenceId, body: { reference_job: job.id }, type: 'reference' } :
        { id: job.taskId, body: { job: job.id }, type: 'task' };
}
